import { useEffect } from 'react';
import LegacyPage from './components/LegacyPage';
import NotFound from './components/NotFound';
import { pages } from './content/pages';

function normalizePath(pathname) {
  if (pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export default function App() {
  const pathname = normalizePath(window.location.pathname);
  const page = pages.find((candidate) => candidate.path === pathname || candidate.aliases.includes(pathname));

  useEffect(() => {
    if (pathname === '/demo') window.location.replace('/#pricing');
    else if (page && pathname !== page.path) {
      window.history.replaceState({}, '', `${page.path}${window.location.search}${window.location.hash}`);
    }
  }, [page, pathname]);

  if (pathname === '/demo') return <div className="route-status">Redirection…</div>;
  if (!page) return <NotFound />;
  return <LegacyPage page={page} />;
}
